import React, { useState, useEffect, useRef, useLayoutEffect } from "react";
import ReactMarkdown from 'react-markdown';
import Fuse from "fuse.js";
import axios from 'axios';
import UploadWrapper from './UploadWrapper.js';
import CreateClient from './CreateClient.js';
import CreateOrder from './CreateOrder.js';
import CreateMeeting from "./CreateMeeting.js";

import { io } from "socket.io-client";
import { useAuthContext } from '../contexts/AuthContext.js';
import { useUploadContext } from "../contexts/UploadContext.js";
import { v4 as uuidv4 } from "uuid";
import AILoadingText from "./AILoadingText.js";
import MessageAttachments from "./MessageAttachments.js";
import { api, API_ORIGIN } from "../apiClient.js";
import { useSocket } from "../contexts/SocketContext";
import CallRoom from "./CallRoom.js";
import { useRtcStore } from "../stores/rtcStore";
import { useNotifications } from "../stores/NotificationsStore.js";
import { linkify } from "../utils/linkify.js";

const PrivateMessageForm = ({
  isSidebarVisible, setIsSidebarVisible,
  selectedProjectData, selectedtopic,
  selectedUser
  // uploadedFiles, setUploadedFiles 
}) => {
  const { AuthData, updateAuthData, user, setUser } = useAuthContext();
  const { socket, connected } = useSocket();
  const [selectedComponent, setSelectedComponent] = useState(null); // 管理顯示的元件
  const [input, setInput] = useState("");
  const [component, setComponent] = useState(null);
  const [azureOpenAIResponse, setAzureOpenAIResponse] = useState([]);
  const [flaskLoading, setFlaskLoading] = useState(null);
  const sentMessageIdsRef = useRef(new Set());
  const [requestingJoin, setRequestingJoin] = useState(false);
  const [status, setStatus] = useState(null); // "approved" | "pending" | "rejected" | "none"

  const notifications = useNotifications();
  const [callId, setCallId] = useState(null);
  // const callStatus = useRtcStore((s) => s.callById[callId]?.status);
  // useEffect(() => {
  //   if (callStatus) setStatus(callStatus);
  //   console.log("callStatus:", callStatus);
  // }, [callStatus]);
  const activeCall = useRtcStore((s) => s.activeCall);
  const clearActiveCall = useRtcStore((s) => s.clearActiveCall);
  const isThisChatCall =
    activeCall &&
    activeCall.kind === "private_call" &&
    activeCall.peerId === selectedUser.user_id;


  const hangup = async () => {
    if (!activeCall) return;

    if (activeCall.status === "ringing") {
      await fetch(`${API_ORIGIN}/api/private-calls/${activeCall.id}/cancel`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
      });
    } else if (activeCall.status === "accepted") {
      await fetch(`${API_ORIGIN}/api/private-calls/${activeCall.id}/end`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
      });
    }

    clearActiveCall();
  };



  const textareaRef = useRef(null);

  // ⭐ 自動調整高度
  useLayoutEffect(() => {
    const el = textareaRef.current;
    if (!el) return;

    el.style.height = "auto";               // 先重置
    el.style.height = `${el.scrollHeight}px`; // 再撐高 // 內容實際高度
  }, [input]);

  const handleKeyDown = (e) => {
    console.log("keydown event:", e);
    if (e.isComposing || e.keyCode === 229) return;
    // Enter 送出、Shift+Enter 換行
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSubmit(e);
    }
  };

  const options = {
    includeScore: true,
    threshold: 0.4,
  };

  const keywords = {
    "新增客戶": ["新增客戶", "創建客戶", "建立客戶", "Client", "dk4cj4"],
    "新增訂單": ["新增訂單", "創建訂單", "建立訂單", "Order", "2/u420 "],
    "上傳": ["上傳", "檔案", "提交檔案", "傳檔", "Upload", "g;4tj06"],
    "新增會議": ["新增會議", "創建會議", "建立會議", "Meeting", "cjo4u4"],
    // "檔名資料": ["檔案", "文件", "查找檔案", "搜尋檔名"],
  };



  const [messages, setMessages] = useState([]);
  // const socketRef = useRef(null); // 建立 socket 參考

  // useEffect(()=>{
  //   setUploadAttachments([])
  // },[])

  useEffect(() => {
    const token = sessionStorage.getItem("flaskAccessToken");
    // console.log("flaskAccessToken:", sessionStorage.getItem("flaskAccessToken"));

    if (!token) return;

    // ⭐ 一定要先檢查 socket 是否存在
    if (!socket) {
      console.log("socket 還沒建立，不註冊事件");
      return;
    }
    // 建立 WebSocket 連線
    // socketRef.current = io("http://localhost:5000", {
    // socketRef.current = io(API_ORIGIN, {
    //   query: { token }
    // });

    // console.log("WebSocket 實例:", socketRef.current);

    const handler = (msg) => {
      console.log("🔥 receive_private_message:", msg);
      // console.log("msg.topic_id:", msg.topic_id);
      // console.log("selectedtopic.id:", selectedtopic.id);

      // if (msg.topic_id !== selectedtopic.id) {
      //   console.log("❌ 不是目前這個 topic 的");
      //   return; // 不是目前這個 topic 的，忽略
      // }

      // ⭐ 如果 server 回傳的 msg 有 tempId，而且是自己發出的，就忽略
      if (msg.tempId && sentMessageIdsRef.current.has(msg.tempId)) {
        // 我們已經畫過這則訊息了 → 不要重複加入
        console.log("❌ 已經畫過這則訊息");
        return;
      }
      // ⭐ 不然就正常加入 message
      setMessages((prev) => [...prev, msg]);
    };
    // socketRef.current.on("receive_message", handler);

    // socketRef.current.on("receive_message", (msg) => {
    //   setMessages((prev) => [...prev, msg]);
    // });

    // 💡 綁定接收事件
    // 即時接收私訊
    socket.on("receive_private_message", handler);
    // // 即時接收私訊
    // socketRef.current.on("receive_private_message", (msg) => {
    //   console.log("📩 收到私訊", msg);
    //   setMessages((prev) => [...prev, msg]);
    // });

    // 清除連線
    return () => {
      if (socket) {
        socket.off("receive_private_message", handler);
        socket.disconnect();
      }
    };
  }, [socket, connected, selectedtopic]);

  useEffect(() => {
    console.log("MessageForm messages:", messages)
  }, [messages])

  useEffect(() => {
    console.log("目前選取的 Topic:", selectedtopic);
  }, [selectedtopic]);

  const fetchPrivateMessages = async (receiverId) => {
    console.log("receiverId:", receiverId)
    const token = sessionStorage.getItem("flaskAccessToken");

    try {
      const res = await fetch(`http://localhost:5000/get_private_messages?receiver_id=${receiverId}`, {
        method: "GET",
        headers: {
          "Authorization": `Bearer ${token}`
        }
      });

      if (!res.ok) throw new Error("無法取得私訊");

      const messages = await res.json();
      console.log("私訊紀錄:", messages);
      setMessages(messages); // 如果你有 useState 管理訊息
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    console.log("selectedUser:", selectedUser)
    setUploadAttachments([])
    fetchPrivateMessages(selectedUser.user_id)
  }, [selectedUser])

  // 監聽 component 的變化，自動顯示/隱藏側邊欄
  useEffect(() => {
    if (component != null) {
      setIsSidebarVisible(true); // 顯示側邊欄
    } else {
      setIsSidebarVisible(false); // 隱藏側邊欄
    }
  }, [component]); // 當 input 改變時執行

  useEffect(() => {
    console.log(azureOpenAIResponse);
  }, [azureOpenAIResponse])

  const { uploadAttachments, updateUploadAttachments, setUploadAttachments } = useUploadContext();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const trimmed = input.trim();
    if (!trimmed) return alert("請輸入文字！");

    // 先準備好這兩個變數，兩個分支都可以用
    let filesForMessage = [];
    let urls = [];
    // 🧠 共用一個 helper：把上傳結果轉成前端要用的格式
    const buildFilesFromUploadResponse = (uploadResponse) => {
      const data = uploadResponse?.data || [];
      const files = data.map((file, idx) => ({
        id: file.id ?? idx,
        file_name: file.file_name,
        file_url: file.view_url,
        file_type: file.file_type,
        file_size: file.file_size,
      }));
      const urlList = files.map((f) => f.file_url);
      return { files, urlList };
    };

    // 檢查 socket 是否已連線
    if (!socket || !connected) {
      alert("WebSocket 尚未連線，請稍後再試");
      return;
    }

    try {
      const uploadResponse = await handleUploadAttachments(trimmed, "");
      const data = uploadResponse?.data || [];
      // 所有附件都掛在同一個 message，所以拿第 1 筆就好
      const first = data[0] || {};
      const message_id = first.id;                // 後端塞的 message_id
      const created_at = first.created_at;        // 後端塞的 created_at（建議後端轉成 iso 字串）

      const { files, urlList } = buildFilesFromUploadResponse(uploadResponse);
      filesForMessage = files;
      urls = urlList;

      // ⭐ 產生 tempId（唯一識別碼）
      const tempId = uuidv4();
      sentMessageIdsRef.current.add(tempId);

      // ⭐ 本地先顯示（立即回饋 UX 比較好）
      // 3️⃣ 本地先把自己的訊息 + 附件畫出來
      setMessages((prev) => [
        ...prev,
        {
          tempId,
          role: "user",
          from: user.name,
          message: trimmed,
          files: filesForMessage,
          created_at: created_at || new Date().toISOString(),
        },
      ]);

      socket.emit("send_private_message", {
        tempId,
        user_id: user?.user_id || 1,
        message_id: message_id,
        message: input,
        receiver_id: selectedUser.user_id,
        file_urls: urls,      // 後端可以用來存 DB 或廣播給其他人
        files: filesForMessage, // 如果你想要 server 也拿到完整 metadata
        created_at: created_at || new Date().toISOString(),
      });

      setInput("");
    } catch (error) {
      console.error("Error in websocket send:", error);
    } finally {
      setFlaskLoading(false);
    }
  };

  const handleChange = (e) => {
    const text = e.target.value;
    let matchedComponent = null;

    for (const [key, words] of Object.entries(keywords)) {
      const fuse = new Fuse(words, options);
      const result = fuse.search(text);
      if (result.length > 0) {
        if (key === "新增客戶") matchedComponent = <CreateClient />;
        else if (key === "新增訂單") matchedComponent = <CreateOrder />;
        else if (key === "上傳") matchedComponent = <UploadWrapper />;
        else if (key === "新增會議") matchedComponent = <CreateMeeting />;
        // else if (key === "檔名資料") {
        //   // 假設 fetchFileUrls 返回檔案列表，並更新到某個元件中
        //   matchedComponent = <div>檔名相關搜尋結果</div>;
        // }
        break;
      }
    }

    setComponent(matchedComponent);
    setInput(e.target.value);
  };

  const toggleSidebar = () => {
    setIsSidebarVisible(!isSidebarVisible);
  };

  // 上傳文件與數據
  const handleUploadAttachments = async (message, target_type) => {
    console.log("handleUploadAttachments target_type:", target_type)
    // e.preventDefault();

    // 從 uploadData.files 中獲取檔案名稱
    // const title = uploadData.files?.[0] || ""; // 獲取第一個檔案名稱，預設為空字串
    // // 收集所有表單數據
    // const fileData = {
    //   // title: uploadData.fileName[0], // 使用同步的檔案名稱
    //   access: selectedAccess,
    //   client: selectedClient,
    //   project: selectedProject,
    //   fileName: uploadData.fileName,
    //   file: uploadData.file,
    // };
    // console.log(fileData);
    // updateUploadData(fileData);

    // console.log("File Data to Update:", fileData); // 確認即將更新的資料

    if (!uploadAttachments || uploadAttachments.length === 0) {
      return { data: [] }; // 沒檔案就給空陣列，前面不會壞掉
    }
    console.log("uploadAttachments:", uploadAttachments); // 確認即將更新的資料

    const payload = new FormData();
    // 遍歷 uploadData 陣列，將每個檔案和元數據附加到 FormData
    uploadAttachments.forEach((attachment, index) => {
      // 將元數據轉為 JSON 字串
      payload.append(`metadata_${index}`, JSON.stringify({
        message_type: "dm",
        user_input: message,
        user_id: user?.user_id || 1,
        file_name: attachment.fileName,
        relative_path: attachment.file?.relativePath || attachment.fileName,  // ✅ 新增這行
        file_type: attachment.file?.type,
        file_size: attachment.file?.size,
        receiver_id: selectedUser.user_id,
      }));
      console.log('file_type:', attachment.file?.type)
      // 附加檔案
      payload.append(`file_${index}`, attachment.file); // 檔案物件
    });
    // for (let pair of payload.entries()) {
    //   console.log(pair[0], pair[1]); // 驗證 payload
    // }

    try {
      console.log(payload);
      // setUploadStatus("上傳中...");
      // const response = await axios.post("http://127.0.0.1:5000/attachments-upload",
      const response = await api.post("/attachments-upload",
        payload,
        {
          headers: {
            // Authorization: `Bearer ${loginResponse.accessToken}`,
            "Content-Type": "multipart/form-data",
            // timeout: 300000  // 5 分鐘
          },
        }
      );
      console.log(response);
      // setUploadStatus("上傳完成！");

      setUploadAttachments([])  // 如果你有這個 state，記得清掉附件

      return response;
      // // 更新 fileUrls 狀態
      // setFileUrls(response.data); // response.data 是一個包含字典的數組

    } catch (error) {
      console.error("上傳失敗:", error);
      // setUploadStatus("上傳失敗！");
    }


    // if (!file || !formData.title || !formData.description || !formData.keywords) {
    //   setUploadStatus("請填寫所有欄位並選擇文件！");
    //   return;
    // }

    // const payload = new FormData();
    // payload.append("file", file);
    // payload.append("title", formData.title);
    // payload.append("description", formData.description);
    // payload.append("keywords", formData.keywords);

    // try {
    //   setUploadStatus("上傳中...");
    //   const response = await axios.post("http://127.0.0.1:5000/upload", payload, {
    //     headers: { "Content-Type": "multipart/form-data" },
    //   });
    //   setUploadStatus(`上傳成功！文件 URL: ${response.data.url}`);
    // } catch (error) {
    //   console.error("上傳失敗:", error);
    //   setUploadStatus("上傳失敗！");
    // }
  };

  const handleFileDrop = (files) => {
    // const newEntries = files.map((file) => ({
    //   fileName: file.name,
    //   file, // 將檔案物件存入
    //   access: "", // 初始為空，submit 時再更新
    //   client: "",
    //   project: "",
    // }));
    // updateUploadData(newEntries); // 將新檔案加入 context
    const newEntries = files.map((file) => ({
      fileName: file.name,
      file, // 儲存檔案物件
      // ...commonData, // 即時同步表單資料
    }));
    updateUploadAttachments(newEntries); // 更新 Context，覆蓋舊檔案
    console.log(uploadAttachments);
  };


  // const startPrivateCall = () => {
  //   const roomName = `dm_${[user.user_id, selectedUser.user_id].sort().join("_")}`;

  //   socket.emit("call:invite", {
  //     type: "audio",      // 也可以 "video"
  //     fromUserId: user.user_id,
  //     toUserId: selectedUser.user_id,
  //     roomName,
  //   });
  // };

  // const status = useRtcStore((s) => s.meetingStatusById[selectedmeeting.id]);

  // const [inCall, setInCall] = useState(false);

  const startPrivateCall = async () => {
    if (!selectedUser?.user_id) return;
    try {
      setRequestingJoin(true);
      const res = await fetch(
        `http://localhost:5000/api/private-calls`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          // credentials: "include",
          body: JSON.stringify({
            callee_id: selectedUser.user_id,
            mode: "audio",
            // note: "我想加入這場會議",
          }),
        }
      );
      const data = await res.json();
      if (!res.ok) {
        alert(data.error || "發起通話失敗");
        return;
      }
      setCallId(data.call_id);

      setStatus(data.status || "ringing");
      const notiId = `call_${data.call_id}`;   // ✅ 用固定 id，後面才能 update
      notifications.add({
        id: notiId,
        type: "call_outgoing",
        title: "撥號中…",
        message: `正在呼叫 ${selectedUser.name || "對方"}`,
        sticky: true, // 你如果有這種欄位就用，沒有也沒關係
        actions: [
          {
            label: "取消",
            onClick: async () => {
              await fetch(`${API_ORIGIN}/api/private-calls/${data.call_id}/cancel`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                credentials: "include",
              });
              notifications.remove(notiId);
            },
          },
        ],
      });
    } catch (err) {
      console.error("handleRequestJoin error", err);
      alert("請求加入失敗");
    } finally {
      setRequestingJoin(false);
    }
  };

  return (
    <div style={{
      height: "100%",
    }}>
      <div><strong>Chat</strong></div>
      <button
        onClick={() => {
          if (!activeCall) {
            startPrivateCall();          // 尚未通話
          } else if (isThisChatCall && activeCall.status === "accepted") {
            hangup();                    // 通話中 → 掛斷
          }
        }}
        disabled={
          activeCall &&
          isThisChatCall &&
          activeCall.status === "ringing"   // 撥號中不能再點
        }
      >
        {!activeCall && "Huddle"}

        {activeCall && isThisChatCall && activeCall.status === "ringing" && "Ringing…"}

        {activeCall && isThisChatCall && activeCall.status === "accepted" && "In Call (Hang up)"}

        {activeCall && !isThisChatCall && "In another call"}
      </button>

      {/* <button onClick={startPrivateCall} disabled={status === "ringing" || status === "accepted"}>
        {status === "ringing" ? "Ringing..." : status === "accepted" ? "In Call" : "Huddle"}
      </button> */}

      {/* {status === "ringing" && (
        <button onClick={cancelPrivateCall} style={{ marginLeft: 8 }}>
          取消
        </button>
      )} */}

      {/* {status === "accepted" && callId && (
        <CallRoom kind="private_call" id={callId} mode="audio" />
      )} */}


      {/* <button onClick={handleRequestJoin} disabled={requestingJoin}>
      </button> */}

      <div className='chat-log-dm'>
        {messages.map((m, i) => (
          <>
            {/* <hr /> */}
            <br></br>
            <div key={i}>
              <div>
                <b>{m.from}</b>
                <span className="message-time">{formatTime(m.created_at)}</span>
              </div>
              {
                m.from !== 'AI'
                  ? <div>{linkify(m.message)}</div>
                  : <ReactMarkdown>{m.message}</ReactMarkdown>
              }
              <MessageAttachments files={m.files} />
            </div>
          </>
        ))}
        {/* <br /> */}
        {/* {azureOpenAIResponse &&
          azureOpenAIResponse.map((msg, index) => (
            <div
              key={index}
              className={`${msg.role === 'user' ? 'question' : ''
                }`}
            >
              <div
                className={`${msg.role === 'user'
                  ? ''
                  : 'response'
                  }`}
              >
                <ReactMarkdown>{msg.content}</ReactMarkdown>
              </div>
            </div>
          )
          )} */}
        {flaskLoading ? <AILoadingText /> : ""}
        {/* 根據不同的回應顯示不同的內容 */}
      </div>

      <form className={`create-form ${isSidebarVisible ? 'sidebar-open' : ''}`}
        onSubmit={handleSubmit}>
        <div className="message-area">
          {/* <input
        type="text"
        value={content}
        onChange={(e) => { setContent(e.target.value) }}
        placeholder="請輸入訊息"
      /> */}
          <div className="message-attachments">
            {uploadAttachments &&
              uploadAttachments.map((uploadAttachment) => {
                return (
                  <div className="message-attachment">
                    {uploadAttachment.fileName}
                  </div>
                )
              })
            }
          </div>
          <div className="message-row">
            <input
              type="file"
              multiple
              // webkitdirectory="true"
              // directory="true"
              onChange={(e) => handleFileDrop(Array.from(e.target.files))}
              style={{ display: "none" }}
              id="fileInput"
            />
            <label
              htmlFor="fileInput"
              className="composer-btn"
            >
              ➕
              {/* 選擇檔案
              <img src='./arrow04.png' style={{
                width: "20%",
              }}></img> */}
            </label>
            <textarea
              ref={textareaRef}
              type="text"
              value={input}
              rows={1}
              // onChange={(e) => setInput(e.target.value)}
              onChange={handleChange}
              onKeyDown={handleKeyDown}
              placeholder="Enter your message..."
            // className="chat-textarea"
            />
            <button type="submit">
              <img className="sent-message" src="./sent.png" alt="送出" />
            </button>
          </div>
        </div>
        <div className="toggle-area">
          {/* 固定在畫面右邊的按鈕 */}
          <button
            type="button" className="toggle-button" onClick={toggleSidebar}>
            {isSidebarVisible ? ">>" : "<<"}
          </button>
        </div>
      </form>

      {/* 可顯示/隱藏的右側區塊 */}
      <div className={`sidebar ${isSidebarVisible ? "visible" : "hidden"}`}>
        {/* {renderComponent()} */}
        {component}
      </div>

      <div style={{ marginTop: "20px" }}>{selectedComponent}</div>
    </div>
  );
}


function formatTime(isoString) {
  // MySQL 裡的時間（通常是 UTC 或 server 時區）
  // 2025-11-21T08:51:30 沒有時區資訊的 ISO 字串，new Date() 會把它當 本地時間 8:51 來解析
  console.log("isoString:", isoString)
  if (!isoString) return "";

  // 如果字串沒有 Z 或時區資訊，就補一個 Z，當成 UTC
  const hasTimezone = /Z$|[+-]\d\d:\d\d$/.test(isoString);
  const normalized = hasTimezone ? isoString : isoString + "Z";

  return new Date(normalized).toLocaleString("zh-TW", {
    // year: "numeric",
    // month: "2-digit",
    // day: "2-digit",
    hour: "numeric",
    minute: "numeric",
    // second: "2-digit",
    hour12: true,
  });

}


export default PrivateMessageForm;
